<template>
    <b-col class="user-settings-sidebar">
        <ul>
            <li>
            <router-link :to="{name: ManagerRouteNames.addMembers}" :active="isActive(ManagerRouteNames.addMembers)" active-class="active">
                <i class="fas fa-users fa-lg profile-icon"></i> <span class="sidebar-info">Add Members</span>
            </router-link>
            </li>
            <li>
            <router-link :to="{name: ManagerRouteNames.businessDetails}" :active="isActive(ManagerRouteNames.businessDetails)" active-class="active">
                <i class="fas fa-business-time fa-lg profile-icon"></i> <span class="sidebar-info">Business Details</span>
            </router-link>
            </li>
            <li>
            <router-link :to="{name: ManagerRouteNames.teamMembers}" :active="isActive(ManagerRouteNames.teamMembers)" active-class="active">
                <i class="fas fa-user-friends fa-lg profile-icon"></i> <span class="sidebar-info">Team Members</span>
            </router-link>
            </li>
        </ul>

    </b-col>
</template>

<script>
import {ManagerMainRoutes, ManagerRouteNames} from "../../../routeNames";

export default {
    computed: {
        ManagerRouteNames() {
            return ManagerRouteNames
        },
        currentRoute() {
            return this.$route.name;
        }
    },
    methods:{
        isActive(routeName) {
            return this.currentRoute === routeName;
        }
    }
}

</script>
